module.exports = __webpack_public_path__ + "img/banner-plus.84c5d4c1.png";